module.exports = __webpack_public_path__ + "static/media/translate.db02dd28.svg";